exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{box-sizing:border-box;font-family:Montserrat,Roboto,arial,sans-serif}body,html{margin:0;padding:0;height:100%;line-height:1.1}*,:after,:before{box-sizing:inherit}", "", {"version":3,"sources":["/./src/src/styles/core.scss"],"names":[],"mappings":"AAAA,KAOI,sBAAsB,8CAC4B,CARtD,UAaI,SAAS,UACC,YACE,eACI,CAhBpB,iBAsBI,kBAAmB,CACpB","file":"core.scss","sourcesContent":[":global {\n  //@import 'base';\n  //@import '~normalize.css/normalize';\n\n  // Some best-practice CSS that's useful for most apps\n  // Just remove them if they're not what you want\n  html {\n    box-sizing: border-box;\n    font-family: Montserrat, Roboto, arial, sans-serif;\n  }\n\n  html,\n  body {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    line-height: 1.1;\n  }\n\n  *,\n  *:before,\n  *:after {\n    box-sizing: inherit;\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap&modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./~/sass-loader?sourceMap!./src/styles/core.scss
// module id = 964
// module chunks = 0